import React, { useContext, useState } from 'react';

import {
  CircularProgress, Typography,
} from '@mui/material';

import Button from '../../../components/Button';
import ContentCard from '../../../components/ContentCard';
import Modal from '../../../components/Modal';
import PasswordReset from '../../../components/PasswordReset';
import SkeletonStack from '../../../components/SkeletonStack';
import { getCurrentUserId } from '../../../services/auth';
import { useGetCurrentUserQuery, useUpdateUserMutation } from '../../../services/users';
import { ThemeContext, ThemeMode } from '../../../theme';
import useSnackBar from '../../../utils/react/hooks/useSnackbar';

import {
  DarkModeSettingContainer, DarkModeSwitch, SettingsContainer, StyledBackdrop,
} from './index.styles';

const Settings = () => {
  const createSnackbar = useSnackBar();
  const userId = getCurrentUserId() || '';
  const { data: currUser, isLoading } = useGetCurrentUserQuery();
  const [updateUser, { isLoading: isUpdateUserLoading }] = useUpdateUserMutation();
  const { initDarkMode, initLightMode } = useContext(ThemeContext);

  const [isPasswordFormOpen, setIsPasswordFormOpen] = useState(false);

  const handleResetComplete = () => {
    createSnackbar('Password reset', 'success');
    setIsPasswordFormOpen(false);
  };

  return (
    <SettingsContainer>
      {isUpdateUserLoading && (
        <StyledBackdrop open>
          <CircularProgress />
        </StyledBackdrop>
      )}
      {isLoading ? <SkeletonStack /> : (
        <>
          <Modal open={isPasswordFormOpen} handleClose={() => setIsPasswordFormOpen(false)}>
            <PasswordReset
              onComplete={handleResetComplete}
              currentEmail={currUser?.data.email}
              resetFormPostComplete
            />
          </Modal>
          <ContentCard title="Password">
            <Button onClick={() => setIsPasswordFormOpen(true)}>Change Password</Button>
          </ContentCard>
          <ContentCard title="Dark Mode">
            <DarkModeSettingContainer>
              <Typography>Light</Typography>
              <DarkModeSwitch
                onChange={(e) => {
                  updateUser({
                    userId,
                    newAttributes: {
                      settings: {
                        themeMode: e.target.checked ? ThemeMode.Dark : ThemeMode.Light,
                      },
                    },
                  });
                  if (e.target.checked) initDarkMode();
                  else initLightMode();
                }}
                disabled={isUpdateUserLoading}
                checked={currUser?.data.settings?.themeMode === ThemeMode.Dark}
                size="medium"
                color="primary"
              />
              <Typography>Dark</Typography>
            </DarkModeSettingContainer>
          </ContentCard>
        </>
      )}
    </SettingsContainer>
  );
};
export default Settings;
